var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_381_8611)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_381_8611)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_381_8611)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_381_8611",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 24.5V11.5H11.5V24.5H24.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_381_8611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0173 22.9671L17.0502 18L22.0173 13.0329L20.4844 11.5L13.9844 18L20.4844 24.5L22.0173 22.9671Z",
    fill: "black"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_381_8611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(11.5 11.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_381_8611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(11.5 11.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_381_8611"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(11.5 11.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.715bb6753952fa11a1056a46b3f0a5a7.svg";
export { ForwardRef as ReactComponent };